import { defineComponent } from 'vue';
import { QCard, QCardSection } from 'quasar';
import BaseComponent from './baseFormMixin.jsx';
import variableBindingMixin from './variableBindingMixin.jsx';
import {
    renderVariableAssistIcon,
    renderVariablePill,
} from './variableBindingUi.jsx';
import FilePickerField from './filePickerField.vue';
import VerticalStack from '../VerticalStack.jsx';

/**
 * File-picker combo + header Controls (e.g. FilePlayer).
 * Variable assist lives in the header toolbar, same as inputWithHeaderBar.
 */
export default defineComponent({
    name: 'sform-filepickerwithheaderbar',
    mixins: [BaseComponent, variableBindingMixin],
    components: {
        VerticalStack,
        QCard,
        QCardSection,
        FilePickerField,
    },
    data: () => ({
    }),
    props: {
    },
    mounted() {
        this.loadComplete();
    },
    computed: {
        showHeaderVariableAssist() {
            return this.variableAssistAllowed && !this.isVariableBindingMode;
        },
        pickerFormatData() {
            return this.element?.formatData
                || this.element?.schema?.formatData
                || {};
        },
    },
    methods: {
        renderHeaderVariableAssist() {
            if (!this.showHeaderVariableAssist)
                return null;

            const emphasize = this._vbHovered || this._vbFocused || this._vbPickerOpen;
            if (!emphasize)
                return null;

            return (
                <div
                    class="c-variable-binding-header-assist"
                    style={{
                        display: 'inline-flex',
                        alignItems: 'center',
                        flex: '0 0 auto',
                        padding: '0 4px',
                    }}
                >
                    {renderVariableAssistIcon({
                        visible: true,
                        pickerOpen: this._vbPickerOpen,
                        onOpenPicker: () => this.openVariablePicker(),
                        menu: this.renderVariablePicker(),
                    })}
                </div>
            );
        },
        renderBoundBody() {
            const name = this.vbBoundName;
            if (!name)
                return null;

            return renderVariablePill({
                name,
                label: this.hasInputLabel ? (this.inputLabel || this.labelText) : undefined,
                onClear: () => this.exitVariableBindingMode(),
                onChange: () => this.openVariablePicker(),
                menu: this.renderVariablePicker(),
            });
        },
        renderLiteralInput() {
            return (
                <FilePickerField
                    modelValue={this.itemvalue || ''}
                    formatData={this.pickerFormatData}
                    label={this.inputLabel}
                    hint={this.hintText}
                    rules={this.rules}
                    compilerErrorFieldProps={this.compilerErrorFieldProps}
                    showBottomSlots={this.showFieldBottomSlots}
                    onUpdate:modelValue={(value) => { this.sync(value); }}
                    onFocus={() => { this._vbFocused = true; this.onFocus(); }}
                    onBlur={() => { this._vbFocused = false; this.onBlur(); }}
                />
            );
        },
    },
    render() {
        const headerAssist = this.renderHeaderVariableAssist();
        const body = this.isVariableBindingMode
            ? this.renderBoundBody()
            : this.renderLiteralInput();

        return (
            <QCard
                flat
                bordered
                class="q-mb-sm q-pb-none c-InputWithHeaderBar"
                onMouseenter={this.onVariableAssistMouseEnter}
                onMouseleave={this.onVariableAssistMouseLeave}
            >
                <QCardSection class="q-pa-none q-pl-xs q-pr-xs">
                    <div
                        class="c-InputWithHeaderBar-toolbar"
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '4px',
                            minHeight: '32px',
                            width: '100%',
                        }}
                    >
                        <div style={{ flex: '1 1 auto', minWidth: 0 }}>
                            <VerticalStack
                                type="HorizontalLayout"
                                name={this.name}
                                root={this.root}
                                parentType="InputWithHeaderBar"
                                controlData={this.element.formatData}
                                controlName={this.Name}
                                scopeitems={this.scopeitems}
                                controlscope={this.controlscope}
                            >
                            </VerticalStack>
                        </div>
                        {headerAssist}
                    </div>
                </QCardSection>
                <QCardSection class="q-pb-none">
                    {body}
                </QCardSection>
            </QCard>
        );
    }
});
